import React from "react";
import { withSafeRotateSvg } from "../../hoc/withSafeRotateSvg";

const CurvedBorderCircularDeep: React.FC<DogsTrust.CurveProps> = ({
	fill = "#FFC800",
	className,
	style,
}) => {
	return (
		<svg
			className={className}
			style={style}
			aria-hidden="true"
			focusable="false"
			viewBox="0 0 623.43 434.39"
			xmlns="http://www.w3.org/2000/svg"
			preserveAspectRatio="xMidYMid slice"
		>
			<path
				fill={fill}
				d="M616.86 0C611.01 237.36 416.76 429.81 178 429.81c-42.17 0-101.69-12.71-178-37.68v42.26h1440V0H616.86Z"
			/>{" "}
		</svg>
	);
};

export default withSafeRotateSvg<DogsTrust.CurveProps>(
	CurvedBorderCircularDeep,
);
